import { Switch, Route, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { Toaster } from 'react-hot-toast';
import EnrollmentsDashboardPageComponent from "./pages/reports-pages/enrollments-dashboard-page.component";
import SessionExpiredModal from "./components/ui/SessionExpiredModal";
import FirmAccessSync from "./components/ui/FirmAccessSync";
import SsoLandingPage from "./pages/sign-in/sso-landing.component";

import SignInPage from "./pages/sign-in/sign-in-page.component";
import SetPasswordPage from "./pages/sign-in/set-password.component";
import ResetPasswordPage from "./pages/sign-in/reset-password.component";
import PageNotFound from "./pages/404/404-page.component";

import DashBoardPage from "./pages/reports-pages/dash-page.component";
import DistributionPage from "./pages/reports-pages/distribution-page.component";
import AdvisorsPage from "./pages/reports-pages/advisors-page.component";
import ClientsSection from "./pages/reports-pages/clients-page.component,";
import CompaniesPage from "./pages/reports-pages/companies-page.component";
import UserProfile from "./pages/reports-pages/user-profile.component";
import SecurityPage from "./pages/reports-pages/security-page.component";
import InvalidTokenPage from "./pages/sign-in/invalid-token-page.component";
import EnrollmentForm from "./pages/reports-pages/enrollment-form.component";

import { setCurrentUser } from "./redux/user/user.actions";
import { selectCurrentUser } from "./redux/user/user.selectors";
import { selectCurrentDistro } from "./redux/distro/distro.selector";
import { CLIENTS_PATH, isClientOnlyForDistro } from "./utils/firmAccess";
import QuotesDashboard from "./pages/reports-pages/quotes-dashboard";
import DepositSummaryPage from "./pages/reports-pages/deposit-summary.component";
import MarketingPage from "./components/marketing/marketing-page";
import VideoPage from "./components/marketing/video-page";
import VideosPage from "./components/marketing/videos-page";
import EnrollmentFillable from "./components/enrollments/enrollment-fillable";

function App({ currentUser, currentDistro }) {
    return (
        <div>
            <SessionExpiredModal />
            <FirmAccessSync />
            <Toaster
                position="top-center"
                toastOptions={{
                    loading: { duration: Infinity },
                    style: {
                        background: '#fff',
                        color: '#374151',
                        boxShadow: '0 4px 24px rgba(0, 0, 0, 0.15)',
                        borderRadius: '12px',
                        padding: '12px 16px',
                    },
                }}
            />
            <Switch>
                <Route exact path="/">
                    <Redirect to="/signin" />
                </Route>
                <Route exact path={"/signin"} component={SignInPage} />
                <Route exact path={"/sso"} component={SsoLandingPage} />
                <Route exact path="/resetpassword" component={ResetPasswordPage} />
                <Route exact path={"/invalid"} component={InvalidTokenPage} />
                <Route exact path={"/enroll/:id"} component={EnrollmentForm} />
                <Route
                    exact
                    path={`/setpassword/:token`}
                    component={SetPasswordPage}
                />

                <Route
                    exact
                    path={`/user/dashboard`}
                    render={() =>
                        !currentUser ? <Redirect to="/signin" />
                            : isClientOnlyForDistro(currentUser, currentDistro) ? <Redirect to={CLIENTS_PATH} />
                            : <DashBoardPage />
                    }
                />

                <Route
                    exact
                    path={`/user/financials`}
                    render={() =>
                        !currentUser ? <Redirect to="/signin" />
                            : isClientOnlyForDistro(currentUser, currentDistro) ? <Redirect to={CLIENTS_PATH} />
                            : <DistributionPage />
                    }
                />

                <Route exact path={`/user/commission`}>
                    <Redirect to="/user/financials" />
                </Route>

                <Route
                    exact
                    path={`/user/depositsummary`}
                    render={() =>
                        !currentUser ? <Redirect to="/signin" />
                            : isClientOnlyForDistro(currentUser, currentDistro) ? <Redirect to={CLIENTS_PATH} />
                            : <DepositSummaryPage />
                    }
                />

                <Route
                    exact
                    path={`/user/enrollments`}
                    render={() =>
                        !currentUser ? <Redirect to="/signin" /> : <EnrollmentsDashboardPageComponent />
                    }
                />

                <Route
                    exact
                    path={`/user/quotes`}
                    render={() =>
                        !currentUser ? <Redirect to="/signin" /> : <QuotesDashboard />
                    }
                />

                <Route
                    exact
                    path={`/user/clients/:type?`}
                    render={({ match }) =>
                        !currentUser ? <Redirect to="/signin" /> : <ClientsSection type={match.params.type} />
                    }
                />

                <Route
                    exact
                    path={`/user/profile`}
                    render={() =>
                        !currentUser ? <Redirect to="/signin" /> : <UserProfile />
                    }
                />

                <Route
                    exact
                    path={`/user/security`}
                    render={() =>
                        !currentUser ? <Redirect to="/signin" />
                            : currentUser.role === "advisor" ? <Redirect to="/user/profile" />
                            : isClientOnlyForDistro(currentUser, currentDistro) ? <Redirect to={CLIENTS_PATH} />
                            : <SecurityPage />
                    }
                />

                <Route
                    exact
                    path={`/user/advisors`}
                    render={() =>
                        !currentUser ? <Redirect to="/signin" /> : <AdvisorsPage />
                    }
                />

                <Route
                    exact
                    path={`/user/companies`}
                    render={() =>
                        !currentUser ? <Redirect to="/signin" /> : <CompaniesPage />
                    }
                />

                <Route
                    exact
                    path={`/user/enrollment-fillable`}
                    render={() =>
                        !currentUser ? <Redirect to="/signin" /> : <EnrollmentFillable />
                    }
                />

                <Route
                    exact
                    path={`/user/marketing`}
                    render={() =>
                        !currentUser ? <Redirect to="/signin" /> : <MarketingPage />
                    }
                />

                <Route
                    exact
                    path={`/user/videos`}
                    render={() =>
                        !currentUser ? <Redirect to="/signin" /> : <VideosPage />
                    }
                />

                <Route
                    exact
                    path={`/user/video/:videoType/:title`}
                    render={(props) =>
                        !currentUser ? <Redirect to="/signin" /> : <VideoPage videoType={props.match.params.videoType} title={props.match.params.title} />
                    }
                />

                <Route component={PageNotFound} />
            </Switch>
        </div>
    );
}

const mapStateToProps = createStructuredSelector({
    currentUser: selectCurrentUser,
    currentDistro: selectCurrentDistro,
});

const mapDispatchToProps = (dispatch) => ({
    setCurrentUser: (user) => dispatch(setCurrentUser(user)),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
